import { ClassProvider } from '@angular/core';
import { AnalyticsService } from './analytics.service';
import { GtmService } from './google-tag-manager';

export const GOOGLE_TAG_MANAGER_PROVIDER: ClassProvider = {
  provide: AnalyticsService,
  useClass: GtmService
};
